export const addresses = {
  providerAddress: "0xB7ca895F81F20e05A5eb11B05Cbaab3DAe5e23cd",
};
